// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1rmHH","form":"styles_form__1EF3S"};